import appConfig from '@/config/app'
import Auth from '@/services/auth'

export default {
  namespaced: true,
  strict: appConfig.store.strict,
  state () {
    return {
      user: null,
      userIsTrainer: false
    }
  },
  mutations: {
    /**
     * Set User
     *
     * @param {*} state
     * @param {*} payload
     */
    setUser (state, payload) {
      state.user = payload
    },
    /**
     * Set isTrainer
     *
     * @param {*} state
     * @param {*} payload
     */
    setUserType (state, payload) {
      state.userIsTrainer = payload
    }
  },
  actions: {
    /**
     * Action to update field value
     *
     * @param {commit} commit
     * @return void
     */
    setAuthUser ({ commit }) {
      commit('setUser', Auth.getUser())
    },
    /**
     * Action to update field value
     *
     * @param {commit} commit
     * @return void
     */
    clearAuthUser ({ commit }) {
      commit('setUser', null)
    },
    /**
     * Identify User Type
     *
     * @param {commit} commit
     * @return boolean
     */
    identifyUserType ({ commit }) {
      commit('setUserType', Auth.isTrainer())
    }
  }
}
